import { eaCollectorWrapper, dataLayerGAWrapper } from '../utils/taggingPlan';
import { getHost } from '../app';
import { getEnv } from '../utils/environment';

export function openPrice(evt, priceName) {
    // Declare all variables
    var i, pricesItem, tablinks;
    
    // Get all elements with class="prices__item" and hide them
    pricesItem = document.getElementsByClassName("prices__item");
    for (i = 0; i < pricesItem.length; i++) {
        pricesItem[i].style.display = "none";
    }
    
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    
    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(priceName).style.display = "block";
    evt.currentTarget.className += " active";
}

document.addEventListener("DOMContentLoaded", () => {
    eaCollectorWrapper([
        'rtgsite', 'professionnel',
        'rtgpg', 'product',
        'rtgpagename', window.espaceProConfig ? window.espaceProConfig.PAGE_NAME : '',
        'path', window.location.pathname,
        'from', getHost()
    ]);

    dataLayerGAWrapper({
        page_type: 'Page Offres', 
        environment: getEnv(),
        error: ''
    });
}, false );
